/**
 * Transaction category values
 */
export enum TransactionRecordCategoryEnum {
	LOCATION = 'location',
	CUSTOMER = 'customer',
	SUPPLIER = 'supplier',
	AGENT = 'agent',
	VEHICLE = 'vehicle',

	RENTAL_AGREEMENT = 'rental_agreement',
	RENTAL_RESERVATION = 'rental_reservation',

	VEHICLE_INSURANCE = 'vehicle_insurance',
	VEHICLE_ROAD_TAX = 'vehicle_road_tax',
	VEHICLE_ROAD_WORTHY_CHECK = 'vehicle_road_worthy_check',
	VEHICLE_MAINTENANCE = 'vehicle_maintenance',
}
